import { usePathname } from 'next/navigation';

export function useActiveLink(path) {
  const pathname = usePathname();

  return pathname === path;
}
